// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__3YkU4","slider":"Switch_slider__3UPTi","round":"Switch_round__q0QJZ"};